import React ,{ useRef, useEffect }from 'react';
import { Messages as PrimeMessages} from 'primereact/messages';
 
import './index.css'

function Messages(props) {
	const { messages, severity}= props

	const msgs = useRef(null)
	
	let sticky = props.sticky ? props.sticky : false

	useEffect(() => {
		if (msgs.current) {
			msgs.current.clear()
			msgs.current.show({ id: '1', sticky, severity:`${severity}`, detail: `${messages}`, closable: false })
		}
	}, [messages])
	
	return <PrimeMessages ref={msgs}  className={props.hideIcon ? 'no-icon-messages' : ''}/>
}

export default Messages


